import { AxiosResponse } from 'axios'

import ClientSDK from '../../../App/ClientSDK'
import {IAPIUserHr, IUserHr} from '../interfaces/IUserHr'

import Transformer from './Transformer'

class Client {
  static getHrUsers = (): Promise<IUserHr[]> =>
    ClientSDK.instance()
      .get(`hr/persons`)
      .then((response: AxiosResponse): IUserHr[] => {
        return response.data.list.map((user: IAPIUserHr) => Transformer.transform(user))
      })
}

export default Client
